export const INIT_PAYLOAD = {
  data: null,
  loading: false,
  success: false,
  error: null,
};
